import React from 'react'
import { hasPermission } from '../components/auth/login/Login';
import VendorAppointments from '../components/vendors/VendorsAppointments/VendorAppointments';

const VendorAppointmentPage = () => {

    const canReadVendor = hasPermission('Self-Guided Tours', 'Vendor', 'read');

    if (!canReadVendor) {
        window.location.href = '/no-permission';
        return null;
    }

    return (
        <div className='outletConainer'>
            <VendorAppointments />
        </div>
    )

}

export default VendorAppointmentPage
